import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getModel } from './selectors';
import * as actions from './actions';

import VibrationFFTComponent from './VibrationFFTComponent';
import { getMaintainedTimestamps } from './helpers';
import { chartViews } from './constants';
import VibrationFFT2DComponent from './FFT2D/VibrationFFT2DComponent';
import VibrationFFTEchart3DComponent from './Echart3D/VibrationFFTEchart3DComponent';
import ErrorView from 'sharedComponents/ErrorBoundary/ErrorView';
import { useReportIssue } from 'sharedHooks/useReportIssue';
import { apiCallStatus } from 'helpers/constants';
import { downloadRawDataV2 } from '../OperationalParametersHeader/actions';


const VibrationFFTContainer = (props) => {
    const { model, actions } = props;
    const { showReportIssue } = useReportIssue();
    const selectedTimestamps = getMaintainedTimestamps(model.selectedTimestamps, model.selectedAsset, model.selectedOrganization);
    const selected2DTimestamp = getMaintainedTimestamps(model.selected2DTimestamp, model.selectedAsset, model.selectedOrganization);
    useEffect(() => {
        if (!model?.fft2DData?.length) { // Execute only while switch assets
            if (!selected2DTimestamp?.length) {
                actions.getFFTV2Data();
            } else {
                actions.getFFTDataByTimestamp(selected2DTimestamp, false, true);
                actions.getFFTDataByTimestamp(selectedTimestamps);
            }
        }
    }, []);

    if (model.downloadRawDataErrorData?.loadingStatus === apiCallStatus.ERROR) {
        return <ErrorView
            errorCode={model.downloadRawDataErrorData.errorCode}
            onRetry={() => actions.downloadRawDataV2()}
            onReportIssue={showReportIssue}
        />;
    }

    if (model.errorData?.loadingStatus === apiCallStatus.ERROR) {
        return <ErrorView
            errorCode={model.errorData.errorCode}
            onRetry={() => actions.getFFTV2Data()}
            onReportIssue={showReportIssue}
        />;
    }

    return model.selectedChartView === chartViews.FFT2D ?
        <VibrationFFT2DComponent {...props} selectedTimestamps={selected2DTimestamp} />
        : model.selectedChartView === chartViews.ECHART3D ?
            <VibrationFFTEchart3DComponent {...props} selectedTimestamps={selectedTimestamps} />
            : <VibrationFFTComponent {...props} selectedTimestamps={selectedTimestamps} />;
};
VibrationFFTContainer.propTypes = {
    model: PropTypes.shape({
        selectedTimestamps: PropTypes.object,
        selected2DTimestamp: PropTypes.object,
        selectedAsset: PropTypes.object,
        selectedOrganization: PropTypes.object,
        fft2DData: PropTypes.array,
        selectedChartView: PropTypes.string,
        downloadRawDataErrorData: PropTypes.shape({
            loadingStatus: PropTypes.string,
            errorCode: PropTypes.number,
        }),
        errorData: PropTypes.shape({
            loadingStatus: PropTypes.string,
            errorCode: PropTypes.number,
        }),
    }),
    actions: PropTypes.shape({
        getFFTV2Data: PropTypes.func,
        getFFTDataByTimestamp: PropTypes.func,
        downloadRawDataV2: PropTypes.func,
    }),
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions, downloadRawDataV2 }, dispatch)
    };
};

const VibrationFFTContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(VibrationFFTContainer);


export default VibrationFFTContainerConn;
